import { render, staticRenderFns } from "./my_info_setting.vue?vue&type=template&id=0580d0e4&scoped=true"
import script from "./my_info_setting.vue?vue&type=script&lang=js"
export * from "./my_info_setting.vue?vue&type=script&lang=js"
import style0 from "./my_info_setting.vue?vue&type=style&index=0&id=0580d0e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580d0e4",
  null
  
)

export default component.exports